export type AvailableLanguage = 'en' | 'cz' | 'fr' | '';
export const AVAILABLE_LANGUAGES: AvailableLanguage[] = ['cz', 'en', 'fr'];
export const DEFAULT_LANGUAGE: AvailableLanguage = 'en';
